import { Location } from '@cobliteam/common-types';
import { lazy } from '@cobliteam/lazy-with-retries';

const RoadSpeedPage = lazy(() => import('../pages/RoadSpeedPage'));

const routes = [{ path: Location.ROAD_SPEED, team: 'squad-gf-core', component: RoadSpeedPage, featureFlag: 'roadSpeedPage', needsGoogleMaps: true }];

export default routes;
